import { render, staticRenderFns } from "./CurrencyPicker.vue?vue&type=template&id=3e644017&"
import script from "./CurrencyPicker.vue?vue&type=script&lang=ts&"
export * from "./CurrencyPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports